<template>
<div class="hello">
    <Menu></Menu>
    <div class="loader-layer" v-show="is_loader">
        <div class="loader"></div> 
    </div>
    <div class="intro" v-show="!is_loader">
        <div class="top">
            <div class="wrap">
                <select name="" id="" v-model="lesson_state" @change="getClassList()">
                    <option value="2">수업중</option>
                    <option value="3">종료</option>
                    <option value="4">수업예정</option>
                </select>
            </div>

        </div>
        <div class="lecture box wrap lecture_wrap" v-for="(lesson,index) in lessonlist" :key="index" :class="{nonemargin:index==0}">
            <div class="enter" v-show="lesson.untact_btn_show == 1 && lesson.class_state == 2">
                <img src="../assets/img/enter.png" alt="" @click="goUntact(lesson.classid,lesson.tutor_code)" class="cur-pointer">
            </div>
            <div class="enter" v-show="lesson.untact_ready_btn_show == 1 && lesson.class_state == 2">
                <img src="../assets/img/ready.png" alt="" class="cur-pointer ">
            </div>
            <div class="con">
                <h3 class="bold">{{lesson.classname}}
                    <!-- <span class="in_box_com on" v-if="lesson.class_state==2">수업중</span>
                    <span class="in_box_com " v-if="lesson.class_state==3">수업종료</span>
                    <span class="in_box_com " v-if="lesson.class_state==1">수업예정</span> -->

                </h3>
                <!-- <span>
                    <div class="in_box_com">수업예정</div>
                    <div class="in_box_com active">수업중</div>
                    <div class="in_box_com">수업완료</div>
                </span> -->
                <table class="mb-20">
                    <tr >
                        <th>수업기간</th>
                        <td>{{lesson.sdate}} ~ {{lesson.edate}}</td>
                    </tr>
                    <tr v-if="lesson.only_write=='N'">
                        <th>수업시간</th>
                        <td >{{lesson.weekLessonText}}  {{lesson.stime}} ~ {{lesson.etime}}</td>                       
                    </tr>
                </table>
                <ul class="chart">
                    <li class="">
                        <p class="">{{lesson.only_write=='Y'?'제출률':'진행률'}}</p>
                        <!-- 차트 부분 -->
                        <radial-progress-bar v-if="lesson.only_write=='Y'" :diameter="130" :innerStrokeWidth="10" :strokeWidth="10" :completed-steps="lesson.writing.write_count" :total-steps="lesson.writing.cnt" :startColor="startcolor" :stopColor="endcolor" :innerStrokeColor="innerStrokeColor">
                            <div class="radial-cirlce">
                                <span class="bold">{{lesson.writing.write_count==""?'0':lesson.writing.write_count }}</span>/{{lesson.writing.cnt }}
                            </div>
                        </radial-progress-bar>
                        <radial-progress-bar v-else :diameter="130" :innerStrokeWidth="10" :strokeWidth="10" :completed-steps="lesson.progress.count_complete_lesson" :total-steps="lesson.progress.total_lesson" :startColor="startcolor" :stopColor="endcolor" :innerStrokeColor="innerStrokeColor">
                            <div class="radial-cirlce">
                                <span class="bold">{{lesson.progress.count_complete_lesson}}</span>/{{lesson.progress.total_lesson}}
                            </div>
                        </radial-progress-bar>

                    </li>
                    <li>
                        <p class="">{{lesson.only_write=='Y' ?'첨삭률':'출석률'}}</p>
                        <!-- 차트 부분 -->
                        <radial-progress-bar v-if="lesson.only_write=='Y'" :diameter="130" :innerStrokeWidth="10" :strokeWidth="10" :completed-steps="lesson.writing.correction_per" :total-steps="100" :startColor="startcolor" :stopColor="endcolor" :innerStrokeColor="innerStrokeColor">
                            <div class="radial-cirlce">
                                <span class="bold">{{lesson.writing.correction_per}}%</span>
                            </div>
                        </radial-progress-bar>
                        <radial-progress-bar  v-else :diameter="130" :innerStrokeWidth="10" :strokeWidth="10" :completed-steps="lesson.rate_attend_new" :total-steps="100" :startColor="startcolor" :stopColor="endcolor" :innerStrokeColor="innerStrokeColor">
                            <div class="radial-cirlce">
                                <span class="bold">{{lesson.rate_attend_new}}%</span>
                            </div>
                        </radial-progress-bar>
                    </li>
                </ul>
                <span class="bold">* 출석률과 진행률 모두 익일 업데이트 됩니다.</span>
            </div>
            <ul class="btn-wrap" v-if="lesson.classboard=='Y'">
                <li><a :href="'/noticelist?classid='+lesson.classid" class="col-point bold">클래스 게시판</a></li>
                <li><a :href="'/class?classid='+lesson.classid" class="col-point bold">Class 자세히 보기</a></li>
            </ul>
            <ul class="btn-wrap" v-else>
                <li style="width:100%"><a :href="'/class?classid='+lesson.classid" class="col-point bold">Class 자세히 보기</a></li>
            </ul>
        </div>

        <div class="inf_box_smile_bg" v-show="inf_box_class_smile===true">
            <div class="inner_box">
                <img src="../assets/img/modal-close.png" class="close-img" alt="" v-on:click="inf_box_class_smile=false">
                <div class="smile_title">{{ inf_name_class_smile }}</div>
                <div class="smile_box clear">
                    <div class="clear">
                        <div class="icon_box float-left" v-on:click="setSmile(1)">
                            <img src="../assets/img/score1.png" class="img_size_smile" v-on:mouseover="changeImgover(1)" v-on:mouseout="changeImgOut(1)" id="smile_img1">
                        </div>
                        <div class="icon_box float-left" v-on:click="setSmile(2)">
                            <img src="../assets/img/score3.png" class="img_size_smile" v-on:mouseover="changeImgover(2)" v-on:mouseout="changeImgOut(2)" id="smile_img3">
                        </div>
                        <div class="icon_box float-left" v-on:click="setSmile(3)">
                            <img src="../assets/img/score5.png" class="img_size_smile" v-on:mouseover="changeImgover(3)" v-on:mouseout="changeImgOut(3)" id="smile_img5">
                        </div>
                    </div>

                    <div class="smile_txt pt-20">현재 수강중인 수업은 어떠신가요?<br><span class="imp">표정 아이콘</span>을 클릭해 주세요!<br>여러분의 소중한
                        의견이 더 좋은 수업을 만듭니다.</div>
                    <div class="cb"></div>
                </div>
                <div class="txt-center modal-txt-close">
                    <span class="tutor" @click="today_close()">오늘 하루 열지 않기</span>
                </div>
            </div>
        </div>
    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
import RadialProgressBar from 'vue-radial-progress'
export default {
    name: 'Intro',
    components: {
        Menu,
        RadialProgressBar
    },
    data: () => ({
        is_loader: true,
        slt_classid: 0,
        inf_box_class_smile: false,
        inf_idx_class_smile: "",
        inf_name_class_smile: "",
        slt_gubun: "CLASS",
        inf_box_talk: true,
        inf_box_class_talk: true,
        lessonlist: [{
            classid: 1,
            num: "001",
            progress: 100,
            classname: "",
            companyname: "",
            sdate: "",
            edate: "",
            stime: "",
            etime: "",
            weekLessonEngText: "",
            classno: "",
            mov: ""
        }],
        w_today: {
            sep: 140,
            view_date: "2018-01-22",
            title: "Don’t be too harsh on them.",
            transtitle: "너무 강하게 하지 말라고."
        },
        tod_biz: {
            seq: 1,
            view_date: "",
            mp3url: "",
            title: "Don’t be too harsh on them.",
            transtitle: "너무 강하게 하지 말라고.",
            example: "",
            transexample: "",
            content: ""
        },
        idx: 0,
        lat: "",
        lng: "",
        show: true,
        fadeInDuration: 1000,
        fadeOutDuration: 1000,
        maxFadeDuration: 1500,
        stop: true,
        startcolor: "#6974FF",
        endcolor: "#53CAFF",
        innerStrokeColor: "#E9E9E9",
        lesson_state: "2"
    }),
    created() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");

    },
    mounted() {
        this.getClassList();
        let today = new Date();

        let year = today.getFullYear(); // 년도
        let month = today.getMonth() + 1; // 월
        let date = today.getDate(); // 날짜
        // let day = today.getDay();
        var todate = year + "" + month + "" + date
        if (localStorage.getItem("smilePop") != todate + "/" + localStorage.getItem("uidx")) {
            this.getSmileInfo4Week();
        }
    },
    methods: {
        hideClassSmile:function(){
            this.inf_box_class_smile = false;
        },
        today_close: function () {
            let today = new Date();

            let year = today.getFullYear(); // 년도
            let month = today.getMonth() + 1; // 월
            let date = today.getDate(); // 날짜
            // let day = today.getDay();
            var todate = year + "" + month + "" + date;
            // console.log(todate);
            localStorage.setItem('smilePop', todate + "/" + localStorage.getItem("uidx"));
            this.inf_box_class_smile = false;
        },
        changeImgOut: function (idx) {
            if (idx == 1) {
                document.getElementById("smile_img1").src = "https://stagehq.carrotenglish.net/resource/itmhq/img/score1_new.png";
            } else if (idx == 2) {
                document.getElementById("smile_img3").src = "https://stagehq.carrotenglish.net/resource/itmhq/img/score3_new.png";
            } else {
                document.getElementById("smile_img5").src = "https://stagehq.carrotenglish.net/resource/itmhq/img/score5_new.png";
            }
        },
        changeImgover: function (idx) {
            // alert("a");
            if (idx == 1) {
                document.getElementById("smile_img1").src = "https://stagehq.carrotenglish.net/resource/itmhq/img/score1_on_new.png";
            } else if (idx == 2) {
                document.getElementById("smile_img3").src = "https://stagehq.carrotenglish.net/resource/itmhq/img/score3_on_new.png";
            } else {
                document.getElementById("smile_img5").src = "https://stagehq.carrotenglish.net/resource/itmhq/img/score5_on_new.png";
            }

        },
        setSmile: function (score) {
            // console.log("set smile state", score, this.inf_idx_class_smile);
            var me = this;
            var params = {
                classid: this.inf_idx_class_smile,
                score: score,
                tmr: Date.now(),
                uidx: localStorage.getItem("uidx"),
            };
            this.axios.post(this.$store.state.host + '/rest/mobile/setSmileInfo4Week_new', params).then(function (res) {
                if (res.data.err == 0) {
                    alert('Thank you. \nHave a nice day~');
                } else {
                    alert(res.data.err_msg);
                }
                me.inf_box_class_smile = false;
            });
        },
        getClassList: function () {
            var me = this;
            var params = {
                uidx: localStorage.getItem("uidx"),
                lesson_state: this.lesson_state
            }
            me.is_loader = true;
            this.axios.get(this.$store.state.host + '/rest/mobile/classlist_new', {
                params: params
            }).then(function (res) {
                console.log(res);
                if (res.data.err == 0) {
                    me.lessonlist = res.data.classes;
                    for (var i = 0; i < me.lessonlist.length; i++) {
                        me.lessonlist[i].cnt_complete_lesson = parseInt(me.lessonlist[i].cnt_complete_lesson);
                        me.lessonlist[i].cnt_total_lesson = parseInt(me.lessonlist[i].cnt_total_lesson);
                        me.lessonlist[i].attend_rate = parseInt(me.lessonlist[i].attend_rate);
                    }
                    me.is_loader = false;
                } else {
                    alert(res.data.err_msg);
                }
                // me.is_loader = false;
                // console.log(me.is_loader);
                // if(me.is_loader == false){
                //     setTimeout(function(){
                //         var targetElement = document.querySelectorAll('.mid_bg .untact_btn');
                //         // console.log(targetElement.length);
                //         for(var i = 0; i < targetElement.length; i++){
                //             me.fadeOut(targetElement[i]);
                //         }
                //     },1000);
                // }
            });
        },
        goUntact: function (classid, tutor_code) {
            var params = {
                classid: classid,
                tutor_code: tutor_code
            };

            this.axios.get(this.$store.state.host + "/rest/mobile/untactTimeCheck", {
                    params: params
                })
                .then(function (res) {
                    if (res.data.err == 0) {
                        window.open('about:blank').location.href = res.data.url;
                    } else {
                        alert(res.data.err);
                    }
                });

            return true;
        },
        getSmileInfo4Week: function () {
            var me = this;
            var params = {
                tmr: Date.now(),
                uidx: localStorage.getItem("uidx"),
            }
            this.axios.get(this.$store.state.host + '/rest/mobile/getSmileInfo4Week_new', {
                params: params
            }).then(function (res) {
                if (res.data.err == 0) {
                    if (res.data.isSmileOn == true) {
                        me.inf_box_class_smile = true;
                        me.inf_name_class_smile = res.data.classname;
                        me.inf_idx_class_smile = res.data.classid;
                    }
                }
            });
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

svg:not(:root) {
    overflow: inherit;
}

.radial-progress-container {
    margin: 0 auto;

    svg {
        overflow: inherit;
    }
}

.radial-cirlce {
    width: 80px;
    height: 80px;
    border-radius: 100%;
    box-shadow: 0px 1px 10px #E9E9E9;

    span {
        line-height: 80px;
    }
}

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

// 인트로
.intro {
    .top {
        padding-top: 110px;
        margin: 0 auto;
        width: 60%;
        background: url("../assets/img/intro-bg.png") no-repeat right -80px;
        background-size: 300px;
        padding-bottom: 10px;
        select {
            border: 1px solid #000;
            color: #000;
            font-size: 14px;
            font-family: 'Noto Sans KR', sans-serif;
        }
    }
}

.lecture {
    position: relative;
    margin-top: 20px;
    .enter {
        position: absolute;
        bottom: 55%;
        right: 20px;
        animation:zoomEx3 .6s ease-in-out infinite;
        -webkit-animation:zoomEx3 .6s ease-in-out infinite;
        -moz-animation:zoomEx3 .6s ease-in-out infinite;
        img {
            max-width: 80px;
        }
    }
    &:first-child{
        margin-top: 0;
    }
    @keyframes zoomEx3 {
        0% {
            -moz-transform:translateZ(0) scale3d(1,1,1);
            -webkit-transform:translateZ(0) scale3d(1,1,1);
            transform:translateZ(0) scale3d(1,1,1);
            }
        50% {
            -moz-transform:translateZ(0) scale3d(1.2,1.2,1);
            -webkit-transform:translateZ(0) scale3d(1.2,1.2,1);
            transform:translateZ(0) scale3d(1.2,1.2,1);
        }
        100% {
             -moz-transform:translateZ(0) scale3d(1,1,1);
            -webkit-transform:translateZ(0) scale3d(1,1,1);
            transform:translateZ(0) scale3d(1,1,1);
        }
    }
   
    .con {
        padding: 30px 30px 20px 30px; 
    }
    table {
        th {
            color: $gray;
            padding: 8px 10px 0 0;        
        }
    }
    .chart {
        width: 100%;
        border-top: 1px dashed $border-color;
        padding-top: 20px;
        li {
            display: inline-block;
            width: calc(100% / 2 - 2px);
            text-align: center;
        }
    }
    .btn-wrap {
        width: 100%;
        border-top: 1px solid $border-color;
        li {
            display: inline-block;
            width: calc(100% / 2 - 2px);
            text-align: center;
            &:first-child {
                border-right: 1px solid $border-color;
            }
            a {
                display: block;
                padding: 20px 0;
            }
        }
    }
}
.nonemargin{
    margin-top: 0;
}
.in_box_com {
    font-size: 12px;
    letter-spacing: 0px;
    opacity: 1;
    border: 1px solid var(--unnamed-color-53caff);
    // background: #53CAFF 0% 0% no-repeat padding-box;
    border: 1px solid #53CAFF;
    border-radius: 4px;
    opacity: 1;
    padding-left: 5px;
    color: #53CAFF;
    padding-right: 5px;
}

.on {
    background: #53CAFF 0% 0% no-repeat padding-box;
    color: #FFFFFF;

}

.footer {
    position: static;
}

.loader-layer {
    position: fixed;
    width: 100%;
    height: 100%;
    //   min-height: 600px;
    background: rgba(0, 0, 0, 0.6);
    z-index: 998;
    left: 0;
    top: 0;
}

.loader {
    position: absolute;
    left: 45%;
    top: 20%;
    z-index: 1;
    /* width: 150px; */
    /* height: 150px; */
    /* margin: -75px 0 0 -75px; */
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #4282f3;
    width: 50px;
    height: 50px;
    margin: 0 0 0 0;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
}
.inf_box_smile_bg {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    padding: 180px 0;

    .inner_box {
        // height: 150px;
        width: calc((100% - 30px)/2);
        min-width: 320px;
        max-width: 500px;
        margin: auto;
        background: white;
        border-radius: 10px;
        position: relative;

        .modal-txt-close {
            span {
                color: white;
                cursor: pointer;
            }
        }

        .close-img {
            position: absolute;
            right: 0;
            top: -30px;
            cursor: pointer;
        }

        .button {
            margin-top: 10px;
            background: #53CAFF 0% 0% no-repeat padding-box;
            border-radius: 3px;
            opacity: 1;
            font-size: 14px;
            letter-spacing: 0px;
            color: #FFFFFF;
            opacity: 1;
            padding: 5px 10px;
            border: none;
        }
    }

    .smile_title {
        color: var(--unnamed-color-53caff);
        text-align: center;
        font-size: 20px;
        letter-spacing: 0px;
        color: #53CAFF;
        opacity: 1;
        font-weight: bold;
        padding-top: 20px;
    }

    .btn_smile_close {
        float: right;
        font-size: 40px;
        color: black;
        margin-right: 10px;
        cursor: pointer;
    }

    .smile_box {
        background-color: #fff;
        text-align: center;
        padding: 20px 5%;
        border-radius: 10px;

        .smile_txt {
            font-size: 16px;
            line-height: 140%;

            // color:white;
            .imp {
                font-size: 16px;
                line-height: 140%;
                font-weight: bold;
                color: #53CAFF;
                // color:$main_txt_color;
            }
        }

        .icon_box {
            padding-top: 10px;
            width: 33.33%;
            text-align: center;
            cursor: pointer;

            .img_size_smile {
                width: 92px;
                height: 92px;
            }
        }
    }
}
@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.intro {
    width: 1200px;
    margin: 0 auto;
}

@media only screen and (max-width: 414px) {
    .intro {
        width: 100%;
        margin: 0 auto;
    }

    .intro {
        .top {
            width: 100%;
            padding-top: 140px;
            background: url("../assets/img/intro-bg.png") no-repeat right -50px;
            background-position-x: 110px;
            min-height: 172px;
            background-size: 300px;
            padding-bottom: 10px;
            border-bottom: 10px solid #F5F5F5;

            select {
                border: 1px solid #000;
                color: #000;
                font-size: 14px;
                font-family: 'Noto Sans KR', sans-serif;
                background: white;
            }
        }

        .inf_box_smile_bg {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.8);
            position: fixed;
            z-index: 999;
            top: 0;
            left: 0;
            padding: 180px 0;

            .inner_box {
                // height: 150px;
                width: calc((100% - 30px)/2);
                min-width: 360px;
                max-width: 500px;
                margin: auto;
                background: white;
                border-radius: 10px;
                position: relative;
            }

            .smile_title {
                color: var(--unnamed-color-53caff);
                text-align: center;
                font-size: 20px;
                letter-spacing: 0px;
                color: #53CAFF;
                opacity: 1;
                font-weight: bold;
                padding-top: 20px;
            }

            .btn_smile_close {
                float: right;
                font-size: 40px;
                color: black;
                margin-right: 10px;
                cursor: pointer;
            }

            .smile_box {
                background-color: #fff;
                text-align: center;
                padding: 20px 5%;
                border-radius: 10px;

                .smile_txt {
                    font-size: 16px;
                    line-height: 140%;

                    // color:white;
                    .imp {
                        font-size: 16px;
                        line-height: 140%;
                        font-weight: bold;
                        color: #53CAFF;
                        // color:$main_txt_color;
                    }
                }

                .icon_box {
                    padding-top: 10px;
                    width: 33.33%;
                    text-align: center;
                    cursor: pointer;

                    .img_size_smile {
                        width: 92px;
                        height: 92px;
                    }
                }
            }
        }
    }

    .modal-txt-close {
        bottom: -45px;

        span {
            color: white;
        }
    }

    .lecture {
        position: relative;
        border-bottom: 10px solid #F5F5F5;

        .enter {
            position: absolute;
            bottom: 55%;
            right: 20px;
            animation: zoomEx3 .6s ease-in-out infinite;
            -webkit-animation: zoomEx3 .6s ease-in-out infinite;
            -moz-animation: zoomEx3 .6s ease-in-out infinite;

            img {
                max-width: 80px;
            }
        }

        @keyframes zoomEx3 {
            0% {
                -moz-transform: translateZ(0) scale3d(1, 1, 1);
                -webkit-transform: translateZ(0) scale3d(1, 1, 1);
                transform: translateZ(0) scale3d(1, 1, 1);
            }

            50% {
                -moz-transform: translateZ(0) scale3d(1.2, 1.2, 1);
                -webkit-transform: translateZ(0) scale3d(1.2, 1.2, 1);
                transform: translateZ(0) scale3d(1.2, 1.2, 1);
            }

            100% {
                -moz-transform: translateZ(0) scale3d(1, 1, 1);
                -webkit-transform: translateZ(0) scale3d(1, 1, 1);
                transform: translateZ(0) scale3d(1, 1, 1);
            }
        }

        @keyframes zoomEx3 {
            0% {
                -moz-transform: translateZ(0) scale3d(1, 1, 1);
                -webkit-transform: translateZ(0) scale3d(1, 1, 1);
                transform: translateZ(0) scale3d(1, 1, 1);
            }

            50% {
                -moz-transform: translateZ(0) scale3d(1.1, 1.1, 1);
                -webkit-transform: translateZ(0) scale3d(1.1, 1.1, 1);
                transform: translateZ(0) scale3d(1.1, 1.1, 1);
            }

            100% {
                -moz-transform: translateZ(0) scale3d(1, 1, 1);
                -webkit-transform: translateZ(0) scale3d(1, 1, 1);
                transform: translateZ(0) scale3d(1, 1, 1);
            }
        }

        .con {
            padding: 20px 30px 20px 30px;
        }

        table {
            th {
                color: $gray;
                padding: 8px 10px 0 0;
            }
        }

        .chart {
            width: 100%;
            border-top: 1px dashed $border-color;
            padding-top: 20px;

            li {
                display: inline-block;
                width: calc(100% / 2 - 2px);
                text-align: center;
            }
        }

        .btn-wrap {
            width: 100%;
            border-top: 1px solid $border-color;

            li {
                display: inline-block;
                width: calc(100% / 2 - 2px);
                text-align: center;

                &:first-child {
                    border-right: 1px solid $border-color;
                }

                a {
                    display: block;
                    padding: 20px 0;
                }
            }
        }
    }
    .lecture_wrap{
        width: 100%;
    }

}
</style>
